import { InitState } from '../reducers/root/initialState'
import { AddressScreenValidationResult } from '../../@types/validation-types'

const hasText = (value: string | undefined): value is string => !!value && value.trim().length > 0

export const selectInsertionData = (state: InitState) => state.insertionFeature.insertionData

export const selectHasRequiredAddressForValuation = (state: InitState): boolean => {
  const { street, city, houseNumber } = selectInsertionData(state)
  return hasText(street) && hasText(city) && hasText(houseNumber)
}

const VALUATION_ADDRESS_FIELDS: (keyof AddressScreenValidationResult)[] = ['street', 'houseNumber', 'postcode', 'city']

export const selectHasValidAddressForValuation = (state: InitState): boolean => {
  const addressValidation = state.insertionFeature.validationResult.address
  if (!addressValidation.validated || !selectHasRequiredAddressForValuation(state)) {
    return false
  }

  return VALUATION_ADDRESS_FIELDS.every((field) => !addressValidation.fields?.[field]?.length)
}

export const selectHasValidConstructionYearForRentIndex = (state: InitState): boolean => {
  const basicInfoValidation = state.insertionFeature.validationResult.basicInfo
  return !!basicInfoValidation.validated && !basicInfoValidation.fields?.constructionYear?.length
}
